<template>
  <div id="app" class="wbs-theme--light" :class="{ 'wbs-side-menu--close': esconderMenuLateral }">
    <router-view :key="$route.fullPath" />
    <notifications group="geral">
      <template slot="body" slot-scope="props">
        <div class="v-notification" :class="props.item.type">
          <div class="v-notification__icon"></div>
          <div class="v-notification__text">
            <div class="notification-title">{{ props.item.title }}</div>
            <div class="notification-content">{{ props.item.text }}</div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>
<script>
  import eventHub from "./utils/eventHub";

  export default {
    data() {
      return {
        esconderMenuLateral: false
      };
    },
    created() {
      eventHub.$on("toggle-menu-lateral", this.toggleMenulateral);
    },
    methods: {
      toggleMenulateral(val) {
        this.esconderMenuLateral = !val;
      }
    }
  };
</script>

<style lang="scss">
  // Carregar icones
  $mdi-font-path: "~@mdi/font/fonts";
  @import "~@mdi/font/scss/materialdesignicons.scss";

  @import "~animate.css/animate.css";

  // Carregar css bootstrap
  @import "~@/style/_bootstrap-variables.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import "~bootstrap-vue/dist/bootstrap-vue.css";

  // Datatable
  @import "~datatables.net-bs4/css/dataTables.bootstrap4.css";

  @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600");
  // Carregar stylo principal
  @import "~@/style/main";
</style>
